export default __webpack_public_path__ + "media/images/ui-icons_ef8c08_256x240-5d1760802b4ebaca262c99f2e4c99e9c.png";